import React from 'react';
import { Button, Checkbox, colors } from '@insurancemenu/imenu-components-lib';
import { useRootStore } from 'store/rootStore';
import { Add, NavigationClose } from '@insurancemenu/imenu-components-lib/dist/icons';
import { ConfigurableEmailInfo } from 'types/emailService';
import { createStyles } from './styles';

interface NotificationEmailCardProps {
  email: ConfigurableEmailInfo;
  isChecked: boolean;
}

const NotificationEmailCard = ({ email, isChecked }: NotificationEmailCardProps): JSX.Element => {
  const classes = createStyles(isChecked);

  const {
    notificationSettingsStore: { updateEmailCheckStatus },
  } = useRootStore();

  const updateEmailStatus = (): void => {
    updateEmailCheckStatus(email.name);
  };

  return (
    <li className={classes.card}>
      <div className={classes.emailInfo}>
        <div className={classes.checkboxWrapper}>
          <Checkbox label={<span>{email.title}</span>} checked={isChecked} onChange={updateEmailStatus} />
        </div>
        {isChecked ? (
          <Button
            type="text"
            leftIconProp={<NavigationClose />}
            color="custom"
            customColor={colors.red[600]}
            onClick={updateEmailStatus}
            className={classes.actionButton}
          >
            Do not receive email
          </Button>
        ) : (
          <Button
            type="text"
            leftIconProp={<Add />}
            color="primary"
            onClick={updateEmailStatus}
            className={classes.actionButton}
          >
            Receive email
          </Button>
        )}
      </div>
      <div className={classes.description}>{email.description}</div>
    </li>
  );
};

export default NotificationEmailCard;
